// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"Dashboard_dashboard__3uk9D","content":"Dashboard_content__5WeR3","fadeIn":"Dashboard_fadeIn__23JgN","fadeOut":"Dashboard_fadeOut__23jMI"};